type Obj = {
    [key: string]: RegExp;
  };

export const regexMap: Obj = {
    'cep': /^[0-9]{5}-[0-9]{3}$/,          
    'cpf': /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
    'cnpj': /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/,
    'texto': /^(?!\s*$).+$/,
    'ano': /^\d{4}$/,
    'mes': /^(0[1-9]|1[0-2])$/, 
    'dia': /^(0[1-9]|[12][0-9]|3[01])$/,
    'data': /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/
  };
